// extracted by mini-css-extract-plugin
module.exports = {"background":"bf_d6","shopping__wrapper__examples":"bf_fh","active":"bf_fj","shopping__wrapper__project":"bf_fk"};